document.addEventListener("DOMContentLoaded", function() {
  const searchForm = document.querySelector('.search-modal__form form.search');
  const searchButton = searchForm.querySelector('.search__button');
  const searchInput = searchForm.querySelector('.search__input');

  if (!searchForm || !searchButton) return;

  // Initially hide search input
  searchForm.classList.add('search--hidden');

  // When user clicks search icon
  searchButton.addEventListener('click', function(e) {
    e.preventDefault();
    if (searchForm.classList.contains('search--hidden')) {
      searchForm.classList.remove('search--hidden');
      searchForm.classList.add('search--active');
      searchInput.focus();
    } else if (searchForm.classList.contains('search--active') && searchInput.value.trim() === '') {
      searchForm.classList.remove('search--active');
      searchForm.classList.add('search--hidden');
    } else {
      searchForm.submit();
    }
  });

  // Hide input when clicking outside
  document.addEventListener('click', function(e) {
    if (!searchForm.contains(e.target)) {
      searchForm.classList.remove('search--active');
      searchForm.classList.add('search--hidden');
    }
  });
});



